import { extendURL } from '@bamboohr/utils/lib/url';
import { isFunction } from 'lodash';

export function urlBuilder(urlBuilderFunc, page) {
	urlBuilderFunc = isFunction(urlBuilderFunc) ? urlBuilderFunc : extendURL;

	return urlBuilderFunc({ page });
}
